import { MinimalLayout } from '@/src/general/ui/layouts/MinimalLayout'
import { useTranslate } from '@/src/lang/useTranslate'

export default function () {
  const { t } = useTranslate()
  return <MinimalLayout title={t('user.profile.favorite-publications')} />
}
